import { useSelector } from 'react-redux';
import { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { selectMCBySwitch } from 'shared/slice/masterControlBySwitchSelectSlice';
import { selectMCByLocation } from 'shared/slice/masterControlSelectByLocationSlice';

import {
  flexBoxCenter,
  justifyContentSpaceBetween,
  layerA180Deg,
  layerADisabled180Deg,
  layerADark,
  layerB,
  layerBDisabled,
} from 'shared/styles/commonStyles';
import styled, { css } from 'styled-components';

import SelectLocations from './SelectLocations';
import InputTempMessage from 'shared/components/userMessages/inputTempMessage';
import { selectUnits } from 'shared/slice/unitsSlice';
import { validateTemp, TEMP_ERROR_MESSAGES } from 'features/masterControl/components/shared/tempValidation';
import MobileControlLayout from 'features/masterControl/components/shared/MobileControlLayout';

import {
  SwitchCardWrapper,
  SwitchCardTitle,
  SwitchSectionTop,
  SwitchFormController,
  SwitchInputSection,
  SwitchInputTemp,
  SwitchButtonSection,
} from 'features/masterControl/components/shared/styles/switchCardStyles';

import {
  SwitchButtonWrapper,
  SwitchButtonHole,
  SwitchButtonTop,
  MessageBoxWrapper,
} from 'features/masterControl/components/shared/styles/controlButtons';

const InstantHeat = ({
  swtName,
  scope,
  handleOnClick,
  handleClose,
  specificLocation,
  disabled,
}) => {
  const isMobile = useMediaQuery({ query: '(max-width:600px)' });

  const type = scope === 'switch' ? 'locations' : 'switches';

  const switchMiddleStatus = useSelector(
    scope === 'switch' ? selectMCBySwitch : selectMCByLocation
  );
  const { selectedOne } = switchMiddleStatus.instantHeat;
  const { fanOnly } = switchMiddleStatus;

  const unitsStatus = useSelector(selectUnits);
  const { isF } = unitsStatus;

  const [tempInput, setTempInput] = useState('');
  const [isButtonSelected, setIsButtonSelected] = useState([false, false]);
  const [openMessageBox, setOpenMessageBox] = useState(false);
  const [messages, setMessages] = useState([]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedOne) {
      handleOnClick(
        'instantHeat',
        'selectA',
        scope,
        0,
        '_',
        type,
        specificLocation
      );
      setTempInput('');
      setOpenMessageBox(true);
      setMessages(TEMP_ERROR_MESSAGES.selectLocation);
    } else {
      const temp = Number(tempInput);

      if (validateTemp(temp, 'instantHeat', isF)) {
        handleOnClick('instantHeat', 'on', scope, temp);
        setTempInput('');
        if (isMobile && scope !== 'switch') {
          handleClose();
        }
      } else {
        setOpenMessageBox(true);
        setMessages(TEMP_ERROR_MESSAGES.instantHeat);
      }
    }

    setIsButtonSelected([false, false]);
  };

  const handleClickSwitchButton = (button) => {
    if (button === 'instantHeat') {
      setIsButtonSelected([true, true]);
    } else if (button === 'fanOnly') {
      setIsButtonSelected([false, true]);
    }
  };

  const handleTgsSubmit = (e) => {
    e.preventDefault();

    if (!isButtonSelected[0] && !isButtonSelected[1]) {
      setMessages(['select program', 'please select program first']);
      setOpenMessageBox(true);
    } else {
      if (isButtonSelected[1] && !isButtonSelected[0]) {
        if (!fanOnly.selectedOne) {
          handleOnClick(
            'fanOnly',
            'selectA',
            scope,
            '_',
            '_',
            type,
            specificLocation
          );
        } else {
          handleOnClick('fanOnly', 'on', scope);
          setIsButtonSelected([false, false]);
        }
      } else {
        handleSubmit(e);
      }
    }
  };


  if (isMobile) {
    return (
      <MobileControlLayout
        scope={scope}
        swtName={swtName}
        specificLocation={specificLocation}
        controlName='instantHeat'
        logoSrc='images/logo-instantHeat.svg'
        label={
          <>
            instant heat <br />program
          </>
        }
        labelSmall={
          <>
            instant heat <br />program
          </>
        }
        hasInput
        tempInput={tempInput}
        onTempChange={(e) => setTempInput(e.target.value)}
        placeholder={isF ? '0\u00B0F' : '0 \u00B0C'}
        onApply={handleSubmit}
        onSubmit={handleSubmit}
        subtitle='instant heat program'
        messages={messages}
        openMessageBox={openMessageBox}
        onCloseMessageBox={() => setOpenMessageBox(false)}
      />
    );
  }


  if (swtName === 'tgs') {
    return (
      <SwitchCardWrapper $messageBoxOpen={openMessageBox} $watermark='images/logo-instantHeat.svg'>
        <SwitchSectionTop>
          <TgsSwitchButton
            onClick={() => handleClickSwitchButton('instantHeat')}
            isSelected={isButtonSelected[0]}
            disabled={disabled}
          >
            <TgsSwitchTop disabled={disabled}>
              <LogoCircle>
                <LogoCircleInner>
                  <LogoCircleTop>
                    <LogoImg src='images/logo-instantHeat.svg' />
                  </LogoCircleTop>
                </LogoCircleInner>
              </LogoCircle>
              <SwitchTitleWrapper>
                <SwitchTitle>instant heat program</SwitchTitle>
              </SwitchTitleWrapper>
            </TgsSwitchTop>
          </TgsSwitchButton>

          <TgsSwitchButton
            onClick={() => handleClickSwitchButton('fanOnly')}
            isSelected={isButtonSelected[1]}
            disabled={disabled}
          >
            <TgsSwitchTop disabled={disabled}>
              <LogoCircle>
                <LogoCircleInner>
                  <LogoCircleTop>
                    <LogoImg src='images/tgs-fanOnly.svg' />
                  </LogoCircleTop>
                </LogoCircleInner>
              </LogoCircle>
              <SwitchTitleWrapper>
                <SwitchTitle>fan only</SwitchTitle>
              </SwitchTitleWrapper>
            </TgsSwitchTop>
          </TgsSwitchButton>
        </SwitchSectionTop>

        <SectionBottom>
          <SelectLocations
            name={
              isButtonSelected[0]
                ? 'instantHeat'
                : isButtonSelected[1]
                ? 'fanOnly'
                : 'instantHeat'
            }
            scope={scope}
            swtName={swtName}
            specificLocation={specificLocation}
          />

          <SectionTgsController onSubmit={handleTgsSubmit} isTgs>
            <TgsInputSection>
              <TgsInputTemp
                type='text'
                onChange={(e) => setTempInput(e.target.value)}
                value={tempInput}
                placeholder='input temp.'
                disabled={isButtonSelected[1] && !isButtonSelected[0]}
              />
            </TgsInputSection>

            <SwitchButtonWrapper
              onClick={handleTgsSubmit}
              $w='80px'
              $h='40px'
              disabled={disabled}
            >
              <SwitchButtonHole disabled={disabled}>
                <SwitchButtonTop disabled={disabled}>
                  apply
                </SwitchButtonTop>
              </SwitchButtonHole>
            </SwitchButtonWrapper>
          </SectionTgsController>
        </SectionBottom>

        {openMessageBox && (
          <MessageBoxWrapper>
            <InputTempMessage
              onClose={() => setOpenMessageBox(false)}
              title='master control'
              subtitle='instant heat and fan only program'
              messages={messages}
            />
          </MessageBoxWrapper>
        )}
      </SwitchCardWrapper>
    );
  }


  return (
    <SwitchCardWrapper $w='100%' $h='355.2px' $watermark='images/logo-instantHeat.svg'>
      <SwitchSectionTop>
        <SwitchCardTitle>instant heat program</SwitchCardTitle>

        <SelectLocations
          name='instantHeat'
          scope={scope}
          swtName={swtName}
        />
      </SwitchSectionTop>

      <SwitchFormController onSubmit={handleSubmit}>
        <SwitchInputSection>
          <SwitchInputTemp
            type='text'
            onChange={(e) => setTempInput(e.target.value)}
            value={tempInput}
            placeholder='input temperature'
          />
        </SwitchInputSection>

        <SwitchButtonSection>
          <SwitchButtonWrapper
            onClick={handleSubmit}
            disabled={disabled}
          >
            <SwitchButtonHole disabled={disabled}>
              <SwitchButtonTop disabled={disabled}>
                apply
              </SwitchButtonTop>
            </SwitchButtonHole>
          </SwitchButtonWrapper>
        </SwitchButtonSection>

        {openMessageBox && (
          <MessageBoxWrapper>
            <InputTempMessage
              onClose={() => setOpenMessageBox(false)}
              title='master control'
              messages={messages}
            />
          </MessageBoxWrapper>
        )}
      </SwitchFormController>
    </SwitchCardWrapper>
  );
};

export default InstantHeat;



const TgsSwitchButton = styled.button`
  width: 189px;
  height: 40px;
  border-radius: 27px;
  ${layerB};
  ${flexBoxCenter};
  margin-bottom: 6px;

  ${(p) =>
    p.isSelected &&
    css`
      border: 1px solid #4ade80;
    `}

  ${(p) =>
    p.disabled &&
    css`
      ${layerBDisabled};
      cursor: not-allowed;
    `}
`;

const TgsSwitchTop = styled.div`
  width: 188px;
  height: 38px;
  border-radius: 27px;
  ${layerA180Deg};
  ${justifyContentSpaceBetween}
  padding: 0 0 0 2px;

  ${(p) =>
    p.disabled &&
    css`
      ${layerADisabled180Deg}
    `}
`;

const LogoCircle = styled.div`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  ${layerB};
  ${flexBoxCenter};
`;

const LogoCircleInner = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  ${layerA180Deg};
  ${flexBoxCenter};
`;

const LogoCircleTop = styled.div`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  ${layerB};
  ${flexBoxCenter}
`;

const LogoImg = styled.img`
  height: 120%;
`;

const SwitchTitleWrapper = styled.div`
  width: 80%;
  ${flexBoxCenter};
`;

const SwitchTitle = styled.span`
  font-size: 8px;
  text-align: center;
`;

const SectionBottom = styled.section``;

const SectionTgsController = styled.form`
  width: 190px;
  height: 37px;
  border-radius: 18px;
  ${layerADark};
  ${justifyContentSpaceBetween};
  padding: 0 1px;
  margin-top: 6px;
`;

const TgsInputSection = styled.section`
  width: 83px;
  height: 35px;
  border-radius: 25px;
  ${layerA180Deg}
  ${flexBoxCenter}
`;

const TgsInputTemp = styled.input`
  width: 75px;
  height: 27px;
  border-radius: 18px;
  ${layerADark}
  font-size: 8rem;

  &::placeholder {
    color: #fff;
    ${(p) =>
      p.disabled &&
      css`
        color: #808080;
      `}
  }

  ${(p) =>
    p.disabled &&
    css`
      background: #334155;
      box-shadow: inset 0px 0px 6px #000000;
    `}
`;
